import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { WebSocketProvider } from "./hooks/useWebSockets";
import { GlobalProvider } from './context/useGlobalContext';
import ErrorBoundary from './components/ErrorBoundary';
import './lib/axios';
import './index.css';

ReactDOM.render(
  <GlobalProvider>
    <ErrorBoundary>
      <WebSocketProvider>
        <App />
      </WebSocketProvider>
    </ErrorBoundary>
  </GlobalProvider>,
  document.getElementById('root')
);

serviceWorker.register();
